import { ValueOf } from '@/shared/lib/interfaces/utils';

export const ACCOUNT_TYPE = {
	PLATFORM_ADMIN: 'PLATFORM_ADMIN',
	B2B: 'B2B',
	B2C: 'B2C',
	OPERATIONAL: 'OPERATIONAL',
} as const;

export type ACCOUNT_TYPE = ValueOf<typeof ACCOUNT_TYPE>;

export const accountTypeLabels: Record<ACCOUNT_TYPE, string> = {
	[ACCOUNT_TYPE.PLATFORM_ADMIN]: 'Platform Admin',
	[ACCOUNT_TYPE.B2B]: 'B2B',
	[ACCOUNT_TYPE.B2C]: 'B2C',
	[ACCOUNT_TYPE.OPERATIONAL]: 'Operational',
};

const TYPE_PERSONAL_ACCOUNT = [ACCOUNT_TYPE.B2B, ACCOUNT_TYPE.B2C] as const;

export type TYPE_PERSONAL_ACCOUNT = (typeof TYPE_PERSONAL_ACCOUNT)[number];
